import { useQuery } from '@tanstack/react-query';
import moment from 'moment/moment';
import { useContext } from 'react';

import fortress from '../api/fortress';
import { AuthContext } from '../contexts/AuthContext';
import { BrandContext } from '../contexts/BrandContext';
import { HeaderContext } from '../contexts/HeaderContext';

export const useBrandSummaryMetrics = () => {
  const { token } = useContext(AuthContext);
  const { brand } = useContext(BrandContext);
  const { selectedDefaultDates, currency, marketplace, selectedPreviousCustomDates } =
    useContext(HeaderContext);

  const params = {
    brandid: brand.brandId,
    tf_s: moment(selectedDefaultDates.tf_s).format('YYYY-MM-DD'),
    tf_e: moment(selectedDefaultDates.tf_e).format('YYYY-MM-DD'),
    pc_s: selectedPreviousCustomDates.pc_s,
    pc_e: selectedPreviousCustomDates.pc_e,
    wow: selectedDefaultDates.timeframe,
    currency: currency,
    marketplace: marketplace,
  };

  return useQuery({
    queryKey: ['BrandSummaryMetrics', params, token],
    queryFn: () => {
      return fortress.get('brand/data/summaryMetrics', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
    },
    // enabled: false,
    throwOnError: () => {
      return false;
    },
  });
};
